import invariant from 'lyjs/es/utils/invariant'
import connectState from 'lyjs/es/components/connectState'
import Trigger from 'lyjs/es/components/Trigger'

function defaultHandleError(err) {
  console.error(err)
}

function getUUID(props) {
  return props.uuid
}

function apiState(options = {}) {
  const {
    fetch,
    handleError = defaultHandleError,
    effects,
    ...otherOptions
  } = options

  invariant(
    typeof fetch === 'function',
    'fetch expected a function, instead recieved %s.',
    fetch
  )

  invariant(
    typeof handleError === 'function',
    'handleError expected a function, instead recieved %s.',
    handleError
  )

  function fetchEffects(setState) {
    return (uuid) => {
      setState({pending: true})
      fetch(uuid)
        .then((data) => {
          setState({data, pending: false})
        })
        .catch((err) => {
          handleError(err)
        })
    }
  }

  return connectState({
    ...otherOptions,
    effects: typeof effects === 'function' ? (setState, getState) => {
      return {
        ...effects(setState, getState),
        fetch: fetchEffects(setState, getState)
      }
    } : {
      ...effects,
      fetch: fetchEffects
    },
    actionName: 'fetch',
    getParams: getUUID
  })(Trigger)
}

export default apiState



// WEBPACK FOOTER //
// ./src/scenes/Main/components/apiState/apiState.js